module.exports = __webpack_public_path__ + "media/遥感目标识别算法及应用.0a89832b.mp4";